import { memo } from 'react';
import { Badge } from '@mantine/core';
import { IconLock, IconUsers } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { ICON_SIZE_XS } from '@/constants/ui';
import { NOTE_VISIBILITY_BADGE_COLORS } from '@/constants/statusColors';
import { NoteVisibility } from '@/types/notes';

interface NoteVisibilityBadgeProps {
  visibility: NoteVisibility;
  showIcon?: boolean;
  className?: string;
}

export const NoteVisibilityBadge = memo(function NoteVisibilityBadge({
  visibility,
  showIcon = true,
  className,
}: NoteVisibilityBadgeProps) {
  const { t } = useTranslation();
  const isPrivate = visibility === NoteVisibility.Private;

  const leftSection = showIcon ? (
    isPrivate ? (
      <IconLock size={ICON_SIZE_XS} />
    ) : (
      <IconUsers size={ICON_SIZE_XS} />
    )
  ) : undefined;

  return (
    <Badge
      className={className}
      color={NOTE_VISIBILITY_BADGE_COLORS[visibility]}
      size="xs"
      variant="light"
      leftSection={leftSection}
    >
      {t(isPrivate ? 'notes.visibility.private' : 'notes.visibility.workspace')}
    </Badge>
  );
});
